function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(10)",
  fill: "#d1d2d2"
}, React.createElement("path", {
  fill: "#EB9200",
  d: "m21.15 51.53c-1.917 0-3.548.604-4.9 1.815-1.353 1.211-2.029 2.682-2.029 4.406 0 1.952.684 3.481 2.05 4.595 1.371 1.113 2.962 1.67 4.787 1.67 1.856 0 3.473-.549 4.857-1.65 1.384-1.098 2.072-2.635 2.072-4.614 0-1.725-.66-3.195-1.981-4.406-1.324-1.212-2.941-1.816-4.856-1.816"
}), React.createElement("path", {
  fill: "#EB9200",
  d: "m40.689 8.666c-1.756-2.67-4.271-4.811-7.48-6.355-3.186-1.537-6.898-2.311-11.04-2.311-4.456 0-8.421.931-11.781 2.77-3.367 1.838-5.962 4.198-7.724 7.02-1.774 2.831-2.668 5.677-2.668 8.461 0 1.49.616 2.877 1.831 4.124 1.221 1.254 2.741 1.89 4.515 1.89 3.02 0 5.09-1.78 6.141-5.261.957-2.887 2.136-5.084 3.5-6.541 1.284-1.372 3.366-2.066 6.187-2.066 2.433 0 4.352.682 5.875 2.086 1.5 1.388 2.229 3.044 2.229 5.058 0 1.015-.235 1.925-.713 2.787-.504.906-1.135 1.741-1.872 2.478-.78.78-2.066 1.957-3.824 3.493-2.048 1.795-3.701 3.372-4.908 4.673-1.252 1.356-2.274 2.953-3.03 4.74-.761 1.804-1.146 3.952-1.146 6.387 0 2.081.58 3.692 1.727 4.79 1.135 1.09 2.548 1.643 4.203 1.643 3.164 0 5.151-1.729 5.741-4.963.306-1.345.529-2.285.68-2.822.137-.486.335-.984.59-1.482.247-.482.639-1.031 1.164-1.635.549-.631 1.296-1.376 2.207-2.207 3.409-3.046 5.813-5.253 7.147-6.559 1.376-1.349 2.576-2.964 3.571-4.806 1.016-1.89 1.533-4.109 1.533-6.598-.002-3.154-.896-6.11-2.661-8.791"
}));

var SvgQuestionMark = function SvgQuestionMark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "20 0 20 64",
    enableBackground: "new 0 0 64 64",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgQuestionMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/question-mark.f021d28f.svg";
export { ForwardRef as ReactComponent };